// Generated by CoffeeScript 1.12.7
(function () {
  module.exports = angular.module("qwilr.viewport", []).factory("ViewportState", function () {
    return {
      blurred: false,
    };
  });
}.call(this));
